import styled from '../../theme/styled-with-theme';
import { Text } from '../Text';
import { pxToRem } from '../../styles/utils';
import { mediaQueries } from '../../styles/media-queries';

export const BlockQuote = styled('blockquote')`
  margin: 0;
  padding: 0;
`;

export const BlockText = styled(Text)`
  font-size: ${({ theme }) => theme.fontSize.p_0};

  ${mediaQueries.desktop} {
    font-size: ${({ theme }) => theme.fontSize.m};
  }
`;

export const Body = styled(Text)`
  font-size: ${({ theme }) => theme.fontSize.p_0};
  line-height: ${({ theme }) => theme.fontSize.ml};
  padding: ${({ theme }) => `0 0 ${theme.spacing.sm}`};

  ${mediaQueries.tablet} {
    font-size: ${({ theme }) => theme.fontSize.m};
    line-height: ${({ theme }) => theme.fontSize.l};
  }

  ${mediaQueries.desktop} {
    padding: ${({ theme }) => `${theme.spacing.l} 0 ${theme.spacing.m}`};
    font-size: ${({ theme }) => theme.fontSize.ml};
    line-height: ${({ theme }) => theme.fontSize.xl};
  }
`;

export const ImageWrapper = styled('div')`
  display: none;

  ${mediaQueries.desktop} {
    display: block;
    width: ${pxToRem(66)};
    max-height: 100%;
  }
`;
